import { Accordion, Code } from "@mantine/core"
import { MarkdownContent } from "atlas_forecasting_app/components/common/markdown_content"

export function ForecastDetailsSections({ writeUp, calculationCode }) {
  if (!writeUp && !calculationCode) return null

  return (
    <Accordion variant="contained" radius="md">
      {writeUp ? (
        <Accordion.Item value="write-up">
          <Accordion.Control>Write-up</Accordion.Control>
          <Accordion.Panel>
            <MarkdownContent source={writeUp} />
          </Accordion.Panel>
        </Accordion.Item>
      ) : null}
      {calculationCode ? (
        <Accordion.Item value="code">
          <Accordion.Control>Code</Accordion.Control>
          <Accordion.Panel>
            <pre className="af-code-block">
              <Code component="code" block={false}>
                {calculationCode}
              </Code>
            </pre>
          </Accordion.Panel>
        </Accordion.Item>
      ) : null}
    </Accordion>
  )
}
